import StringUtils from 'lib/StringUtils';

export const companyDomainEmailTooltip = 'This email address is registered as a company domain, '
    + 'so email communications associated with this customer will not be stored.';

export const companyDomainEmailConfirmMessage = 'You are attempting to send an email to an institutional company address. '
    + 'Please remember that replies and the history associated with this domain will not be stored in AMX. '
    + 'Do you wish to proceed with sending?';

export const isCompanyDomainEmail = (email, companyListDomain = []) => {
    if (StringUtils.isEmpty(email) || !email.includes('@')) return false;

    const domain = email.trim().split('@').pop()?.toLowerCase();
    return companyListDomain.some((companyDomain) => domain === companyDomain.toLowerCase());
};

export const hasCompanyDomainEmail = (emails, companyListDomain = []) => (
    (emails || []).some((email) => isCompanyDomainEmail(email, companyListDomain))
);
